'use client';

import { ReactNode, createContext, useContext } from 'react';

type Context = <T>(
  url: URL,
  options?: RequestInit
) => Promise<{ result: T; count?: number }>;

const ResourcesContext = createContext<Context | null>(null);

interface Props {
  children: ReactNode;
}

const ResourcesProvider = ({ children }: Props) => {
  const value = async <T,>(
    url: URL,
    options: RequestInit = {}
  ): Promise<{ result: T; count?: number }> => {
    const response = await fetch(url, options);
    if (response.ok) return response.json();

    const text = await response.text();
    throw new Error(decodeURI(text));
  };

  return (
    <ResourcesContext.Provider value={value}>
      {children}
    </ResourcesContext.Provider>
  );
};

function useResources() {
  const context = useContext(ResourcesContext);
  if (!context) throw new Error('useResources requires a context!');

  return context;
}

export { ResourcesProvider, useResources };
